// extracted by mini-css-extract-plugin
module.exports = {"trigger-events-container":"inspector-inputs_trigger-events-container__1zaRQ"};